import { render, staticRenderFns } from "./TopHitEntries.vue?vue&type=template&id=05efb13e&scoped=true"
import script from "./TopHitEntries.vue?vue&type=script&lang=js"
export * from "./TopHitEntries.vue?vue&type=script&lang=js"
import style0 from "./TopHitEntries.vue?vue&type=style&index=0&id=05efb13e&prod&scoped=true&lang=css"
import style1 from "./TopHitEntries.vue?vue&type=style&index=1&id=05efb13e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05efb13e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu,VSkeletonLoader,VTooltip})
